import { AsideInfo, Copyable } from '@components'

import { Flex, Space, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface VatPaymentReferenceSectionProps {
  transactionId: string | null
}

export const VatPaymentReferenceSection = ({ transactionId }: VatPaymentReferenceSectionProps): ReactElement | null => {
  const { t } = useTranslation()

  return (
    <AsideInfo.Item>
      <Flex flexDirection="column" alignItems="center">
        <Space size="s12" />

        <Text variant="bodySM" colorVariant="secondary">
          {t('vat_declarations.status_card.payment_reference')}
        </Text>

        <Space size="s4" />

        {transactionId ? (
          <Copyable valueToCopy={transactionId} renderAs="text" weight="bold">
            {transactionId}
          </Copyable>
        ) : (
          <Text weight="bold">{'-'}</Text>
        )}
      </Flex>
    </AsideInfo.Item>
  )
}
